import React, { useEffect, useState } from 'react';
import { ArrowDown, Github, Linkedin, Download } from 'lucide-react';
import { Button } from './ui/button';
import { personalInfo } from '../mock';

const Hero = () => {
  const [text, setText] = useState('');
  const fullText = personalInfo.tagline;
  const [isTyping, setIsTyping] = useState(true);

  useEffect(() => {
    if (isTyping && text.length < fullText.length) {
      const timeout = setTimeout(() => {
        setText(fullText.slice(0, text.length + 1));
      }, 50);
      return () => clearTimeout(timeout);
    } else if (text.length === fullText.length) {
      setIsTyping(false);
    }
  }, [text, isTyping, fullText]);

  const handleDownloadResume = () => {
    // Create a link element and trigger download
    const link = document.createElement('a');
    link.href = 'https://customer-assets.emergentagent.com/job_99ca70fb-c06e-43f0-ba32-17005a6e3699/artifacts/30fl8op5_Resume_BharathYalagi.pdf';
    link.download = 'Bharath_Yalagi_Resume.pdf';
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const scrollToProjects = () => {
    document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-b from-[#0a0a0a] via-[#0d0d1a] to-[#0a0a0a]">
      {/* Animated background particles */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute w-96 h-96 bg-blue-500/10 rounded-full blur-3xl top-20 left-20 animate-pulse"></div>
        <div className="absolute w-96 h-96 bg-cyan-500/10 rounded-full blur-3xl bottom-20 right-20 animate-pulse" style={{ animationDelay: '1s' }}></div>
        <div className="absolute w-64 h-64 bg-blue-400/5 rounded-full blur-2xl top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 animate-pulse" style={{ animationDelay: '0.5s' }}></div>
      </div>

      <div className="relative z-10 text-center px-6 max-w-5xl">
        {/* Main Name with glossy effect */}
        <h1 className="text-7xl md:text-9xl font-bold mb-6 tracking-tight">
          <span className="bg-gradient-to-r from-white via-blue-100 to-cyan-200 bg-clip-text text-transparent animate-gradient drop-shadow-[0_0_30px_rgba(59,130,246,0.3)]">
            {personalInfo.name}
          </span>
        </h1>

        {/* Typing effect tagline */}
        <div className="h-20 md:h-16 mb-8">
          <p className="text-lg md:text-xl text-gray-400 max-w-3xl mx-auto">
            {text}
            <span className="animate-pulse">|</span>
          </p>
        </div>

        {/* CTA Buttons */}
        <div className="flex gap-4 justify-center items-center mb-12">
          <Button
            onClick={scrollToProjects}
            size="lg"
            className="bg-gradient-to-r from-blue-600 to-cyan-600 hover:from-blue-500 hover:to-cyan-500 text-white px-8 py-6 text-lg rounded-lg transition-all duration-300 shadow-[0_0_20px_rgba(59,130,246,0.4)] hover:shadow-[0_0_30px_rgba(59,130,246,0.6)] hover:scale-105 border border-blue-400/20"
          >
            Explore My Work
            <ArrowDown className="ml-2 w-5 h-5 animate-bounce" />
          </Button>
          
          <Button
            onClick={handleDownloadResume}
            size="lg"
            variant="outline"
            className="border-2 border-blue-500/50 hover:border-blue-400 text-white px-8 py-6 text-lg rounded-lg transition-all duration-300 hover:bg-blue-500/10 hover:scale-105 hover:shadow-[0_0_20px_rgba(59,130,246,0.3)]"
          >
            <Download className="mr-2 w-5 h-5" />
            Resume
          </Button>
        </div>

        {/* Social Links */}
        <div className="flex gap-6 justify-center mb-16">
          <a
            href={personalInfo.github}
            target="_blank"
            rel="noopener noreferrer"
            className="p-3 rounded-full border border-gray-700 hover:border-blue-500 transition-all duration-300 hover:bg-blue-500/10 hover:scale-110 hover:shadow-[0_0_15px_rgba(59,130,246,0.4)] group backdrop-blur-sm"
          >
            <Github className="w-6 h-6 text-gray-400 group-hover:text-blue-400 transition-colors" />
          </a>
          <a
            href={personalInfo.linkedin}
            target="_blank"
            rel="noopener noreferrer"
            className="p-3 rounded-full border border-gray-700 hover:border-cyan-500 transition-all duration-300 hover:bg-cyan-500/10 hover:scale-110 hover:shadow-[0_0_15px_rgba(6,182,212,0.4)] group backdrop-blur-sm"
          >
            <Linkedin className="w-6 h-6 text-gray-400 group-hover:text-cyan-400 transition-colors" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default Hero;